(() => {
  'use strict';
  if (window.RavinDesktopQuickBuyV1) return;
  window.RavinDesktopQuickBuyV1 = true;

  const desktop = window.matchMedia('(min-width: 990px)');
  const selector = '[data-rv-pdp-garment-file][data-ravin-pdp-editorial]';
  const instances = new Map();
  const arabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  function setup(root) {
    if (instances.has(root)) return;
    const form = root.querySelector('form[data-product-form]');
    const purchase = root.querySelector('[data-rpa-pdp-purchase-controls]');
    const mainButton = root.querySelector('[data-add-to-cart]');
    const rail = root.querySelector('.rpa-pdp-right');
    if (!form || !purchase || !mainButton || !rail) return;

    const controller = new AbortController();
    const signal = controller.signal;
    let dock = null;
    let sizeInputs = [];
    let sizeButtons = [];
    let frame = 0;
    let syncFrame = 0;
    let observer = null;

    function removeDock() {
      if (observer) observer.disconnect();
      observer = null;
      if (dock) dock.remove();
      dock = null;
      sizeInputs = [];
      sizeButtons = [];
    }

    function createDock() {
      if (!desktop.matches || dock) return;
      const ar = arabic();
      dock = document.createElement('aside');
      dock.className = 'rv-desktop-quickbuy';
      dock.dataset.ravinDesktopQuickbuy = '';
      dock.hidden = true;
      dock.dir = ar ? 'rtl' : 'ltr';
      dock.setAttribute('aria-label', ar ? 'شراء سريع' : 'Quick buy');
      dock.innerHTML = [
        '<div class="rv-desktop-quickbuy__heading">',
          '<div class="rv-desktop-quickbuy__eyebrow">', ar ? 'الأسعار والعروض' : 'PRICE / PROMOTIONS', '</div>',
          '<button class="rv-desktop-quickbuy__wishlist" type="button" data-rvqb-wishlist hidden aria-label="',
          ar ? 'احفظ في المفضلة في ريفين' : 'Save to MY RAVIN wishlist',
          '" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg></button>',
        '</div>',
        '<div class="rv-desktop-quickbuy__title" data-rvqb-title></div>',
        '<div class="rv-desktop-quickbuy__prices" aria-live="polite">',
          '<span class="rv-desktop-quickbuy__price" data-rvqb-price dir="auto"></span>',
          '<span class="rv-desktop-quickbuy__compare" data-rvqb-compare dir="auto" hidden></span>',
          '<span class="rv-desktop-quickbuy__discount" data-rvqb-discount hidden></span>',
        '</div>',
        '<div class="rv-desktop-quickbuy__savings" data-rvqb-savings dir="auto" hidden></div>',
        '<div class="rv-desktop-quickbuy__selection" data-rvqb-selection></div>',
        '<div class="rv-desktop-quickbuy__size-section" data-rvqb-size-section hidden>',
        '<span class="rv-desktop-quickbuy__size-label">', ar ? 'المقاس' : 'SIZE', '</span>',
        '<div class="rv-desktop-quickbuy__sizes" data-rvqb-sizes role="group" aria-label="',
        ar ? 'اختر المقاس' : 'Choose size', '"></div></div>',
        '<button type="button" class="rv-desktop-quickbuy__buy" data-rvqb-buy disabled>',
        ar ? 'أضف للسلة' : 'Add to cart', '</button>'
      ].join('');
      dock.querySelector('[data-rvqb-title]').textContent =
        root.querySelector('.rpa-pdp-product-heading')?.textContent?.trim() || document.title;
      document.body.appendChild(dock);

      const sizeContainer = Array.from(form.querySelectorAll('[data-variant-container]'))
        .find(el => /^(size|المقاس|مقاس)$/i.test((el.dataset.variantContainer || '').trim()));
      sizeInputs = sizeContainer ? Array.from(sizeContainer.querySelectorAll('input[data-option-input]'))
        .filter(input => !/^DEF$/i.test(input.value.trim())) : [];
      const sizes = dock.querySelector('[data-rvqb-sizes]');
      dock.querySelector('[data-rvqb-size-section]').hidden = !sizeInputs.length;
      for (const input of sizeInputs) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rv-desktop-quickbuy__size';
        button.textContent = input.value;
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', (ar ? 'المقاس' : 'Size') + ' ' + input.value);
        button.addEventListener('click', () => {
          if (button.disabled || input.checked || !desktop.matches) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          scheduleSync();
        }, { signal });
        sizes.appendChild(button);
        sizeButtons.push(button);
      }
      dock.querySelector('[data-rvqb-buy]').addEventListener('click', () => {
        if (!desktop.matches || !root.isConnected || mainButton.disabled || root.addingToCart) return;
        mainButton.click();
        scheduleSync();
      }, { signal });
      dock.querySelector('[data-rvqb-wishlist]').addEventListener('click', () => {
        const source = purchase.querySelector('.rpa-pdp-price-kicker .rvw-heart');
        if (source && !source.disabled) source.click();
      }, { signal });
      observer = new MutationObserver(scheduleSync);
      observer.observe(purchase, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-pressed', 'aria-label', 'class', 'style']
      });
      sync();
    }

    function setText(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }

    function sync() {
      syncFrame = 0;
      if (!dock || !desktop.matches) return;
      const price = root.querySelector('[data-final-price]');
      const original = root.querySelector('[data-original-price]');
      const discount = root.querySelector('[data-discount-badge]');
      const savings = root.querySelector('[data-savings]');
      setText(dock.querySelector('[data-rvqb-price]'), price?.textContent?.trim() || '');
      for (const [source, key] of [
        [original, '[data-rvqb-compare]'],
        [discount, '[data-rvqb-discount]'],
        [savings, '[data-rvqb-savings]']
      ]) {
        const target = dock.querySelector(key);
        const value = source?.textContent?.trim() || '';
        const showing = Boolean(value) && !source?.hidden &&
          source?.style.display !== 'none' && source?.getAttribute('aria-hidden') !== 'true';
        target.hidden = !showing;
        if (showing) setText(target, value);
      }
      const heart = purchase.querySelector('.rpa-pdp-price-kicker .rvw-heart');
      const dockHeart = dock.querySelector('[data-rvqb-wishlist]');
      dockHeart.hidden = !heart;
      if (heart) {
        dockHeart.disabled = heart.disabled;
        dockHeart.setAttribute('aria-pressed', heart.getAttribute('aria-pressed') || 'false');
        dockHeart.setAttribute('aria-label', heart.getAttribute('aria-label') ||
          (arabic() ? 'احفظ في المفضلة في ريفين' : 'Save to MY RAVIN wishlist'));
      }
      const selected = Array.from(form.querySelectorAll('[data-variant-container]'))
        .map(group => {
          const input = group.querySelector('input[data-option-input]:checked');
          return input ? input.value : '';
        }).filter(Boolean);
      setText(dock.querySelector('[data-rvqb-selection]'), selected.join(' · '));

      const chosen = new Map(Array.from(
        form.querySelectorAll('[data-option-input]:checked'),
        input => [Number(input.dataset.optionPosition), input.value]
      ));
      const variants = Array.isArray(root.productData) ? root.productData : [];
      sizeInputs.forEach((input, index) => {
        const button = sizeButtons[index];
        const position = Number(input.dataset.optionPosition);
        const matches = variants.filter(variant => Array.isArray(variant.options) &&
          variant.options[position - 1] === input.value &&
          Array.from(chosen).every(([otherPosition, value]) =>
            otherPosition === position || variant.options[otherPosition - 1] === value));
        button.disabled = input.disabled || (variants.length > 0 && matches.length === 0);
        button.classList.toggle('is-selected', input.checked);
        button.classList.toggle('is-unavailable-online', !window.RavinLocal?.isBranch && matches.length > 0 && !matches.some(v => v.available));
        button.setAttribute('aria-pressed', String(input.checked));
      });
      const buy = dock.querySelector('[data-rvqb-buy]');
      buy.disabled = Boolean(mainButton.disabled);
      setText(buy, mainButton.textContent?.trim() || mainButton.dataset.defaultLabel || (arabic() ? 'أضف للسلة' : 'Add to cart'));
      buy.setAttribute('aria-disabled', String(buy.disabled));
    }

    function scheduleSync() {
      if (!syncFrame) syncFrame = window.requestAnimationFrame(sync);
    }

    function topOffset() {
      let top = 14;
      const header = document.querySelector('#shopify-section-header') ||
        document.querySelector('.shopify-section-header') ||
        document.querySelector('.section-header');
      if (header) {
        const rect = header.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top >= -8 && rect.bottom < window.innerHeight * 0.55) {
          top = Math.max(top, rect.bottom + 12);
        }
      }
      return top;
    }

    function position() {
      frame = 0;
      if (!desktop.matches) {
        removeDock();
        return;
      }
      createDock();
      if (!dock || !root.isConnected) return;
      const rootRect = root.getBoundingClientRect();
      const railRect = rail.getBoundingClientRect();
      const buttonRect = mainButton.getBoundingClientRect();
      const top = topOffset();
      const width = Math.min(390, railRect.width, window.innerWidth - 24);
      const bottom = Math.max(14, Math.min(24, window.innerHeight * .02));
      const shouldShow = width >= 230 &&
        buttonRect.bottom < top - 8 &&
        rootRect.bottom > window.innerHeight - bottom + 2 &&
        rootRect.top < window.innerHeight &&
        railRect.right > 12 && railRect.left < window.innerWidth - 12;
      dock.hidden = !shouldShow;
      if (!shouldShow) return;
      dock.style.width = Math.round(width) + 'px';
      dock.style.left = Math.round(Math.max(12, Math.min(railRect.left, window.innerWidth - width - 12))) + 'px';
      dock.style.top = 'auto';
      dock.style.bottom = Math.round(bottom) + 'px';
      if (dock.getBoundingClientRect().top < top + 16) {
        dock.hidden = true;
        return;
      }
      scheduleSync();
    }

    function schedulePosition() {
      if (!frame) frame = window.requestAnimationFrame(position);
    }

    function viewportChanged() {
      if (!desktop.matches) removeDock();
      schedulePosition();
    }

    window.addEventListener('scroll', schedulePosition, { passive: true, signal });
    window.addEventListener('resize', viewportChanged, { passive: true, signal });
    window.addEventListener('pageshow', viewportChanged, { signal });
    desktop.addEventListener?.('change', viewportChanged, { signal });
    form.addEventListener('change', scheduleSync, { signal });
    root.addEventListener('ravin:variantChanged', scheduleSync, { signal });
    root.addEventListener('ravin:priceChanged', scheduleSync, { signal });
    document.addEventListener('ravin:tier:updated', scheduleSync, { signal });

    instances.set(root, () => {
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
      if (syncFrame) window.cancelAnimationFrame(syncFrame);
      removeDock();
      instances.delete(root);
    });
    schedulePosition();
  }

  function mount(scope) {
    if (scope.matches?.(selector)) setup(scope);
    scope.querySelectorAll?.(selector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) {
      if (event.target.contains(root) || event.target === root) cleanup();
    }
  });
})();
